import { render, staticRenderFns } from "./AActivityStream.vue?vue&type=template&id=08ccd6ad&scoped=true"
import script from "./AActivityStream.vue?vue&type=script&lang=js"
export * from "./AActivityStream.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ccd6ad",
  null
  
)

export default component.exports